export enum CollapseToggleMode {
  CloseAll = 'close_all',
  OpenInteresting = 'open_interesting',
  OpenAll = 'open_all'
}
